<div class="modal-body">
  <h5>
    {{ deleteConfirmationText }}
  </h5>
</div>
<div class="modal-footer">
  <button nf-button (click)="activeModal.dismiss()">Cancel</button>
  <button nf-button="delete" ngbAutoFocus (click)="delete()">
    {{ deleteButtonText }}
  </button>
</div>
